import * as React from 'react';

const PixabayLink: React.SFC = () => (
  <a href="https://pixabay.com/" rel="noopener noreferrer" target="_blank">
    Pixabay
  </a>
);

export default PixabayLink;
